module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"ok":"Ok","cancel":"Cancelar"},"en":{"ok":"Ok","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
